import React, {useMemo} from 'react'
import {default as ReactSelect} from "react-select";
import countryList from 'react-select-country-list'



function CountrySelector(props) {
    const options = useMemo(() => countryList().getData(), [])

    const option = options.map((v) => ({label: v.label, value: v.label}));

    return <ReactSelect styles={{
        control: (provided) => ({
            ...provided,
            border: '0.5px solid #054163',
            borderRadius: '4px',
            fontSize: '14px',
            color: '#054163',
            '&:hover': {
              borderColor: '#054163',
            },
          }),
          option: (provided, state) => ({
            fontSize: '14px',
            color: state.isSelected ? '#ffffff' : '#4a5568',
            backgroundColor: state.isSelected ? '#054163' : 'transparent',
            padding: '10px',
            '&:hover': {
              backgroundColor: '#cbd5e0',
            },
          }),
       
    }}
    components={{
        IndicatorSeparator: () => null,
    }}
     {...props} options={option}
                        value={typeof props.value === 'string' ? option.find((v) => v.value === props.value) : props.value}/>
}

export default CountrySelector
